import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import ProfilesPage from "@/pages/ProfilesPage";
import HomePage from "@/pages/HomePage";
import LearnPage from "@/pages/LearnPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import { getProfile } from "@/lib/api";

const STORAGE_KEY = "tinylearn_profile_id";

export default function App() {
  const [profile, setProfile] = useState(null);
  const [ready, setReady] = useState(false);

  const refreshProfile = useCallback(async (id) => {
    try {
      const p = await getProfile(id);
      setProfile(p);
      return p;
    } catch (e) {
      localStorage.removeItem(STORAGE_KEY);
      setProfile(null);
      return null;
    }
  }, []);

  useEffect(() => {
    const id = localStorage.getItem(STORAGE_KEY);
    if (id) {
      refreshProfile(id).finally(() => setReady(true));
    } else {
      setReady(true);
    }
  }, [refreshProfile]);

  const selectProfile = (p) => {
    localStorage.setItem(STORAGE_KEY, p.id);
    setProfile(p);
  };

  const logout = () => {
    localStorage.removeItem(STORAGE_KEY);
    setProfile(null);
  };

  if (!ready) return <div className="app-shell" data-testid="app-loading" />;

  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route
          path="/"
          element={
            profile ? (
              <Navigate to="/home" replace />
            ) : (
              <ProfilesPage onSelect={selectProfile} />
            )
          }
        />
        <Route
          path="/home"
          element={
            profile ? (
              <HomePage profile={profile} onSwitch={logout} refreshProfile={refreshProfile} />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/learn/:category"
          element={
            profile ? (
              <LearnPage profile={profile} refreshProfile={refreshProfile} />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/payment/success"
          element={<PaymentSuccess profile={profile} refreshProfile={refreshProfile} />}
        />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
